export default __webpack_public_path__ + "static/media/ai_lidarActive.52ecc230.svg";